/**
 * Extract the 11-character YouTube video id from a URL (YTI-2).
 *
 * Handles the four shapes a coach might paste: watch?v=, youtu.be/, shorts/,
 * embed/. Returns null for anything that is not a recognised YouTube URL, so
 * callers can conditionally render the embed player.
 *
 * Mirrors the backend `extract_video_id` in app/services/youtube_transcript.py.
 */
const PATTERNS: RegExp[] = [
  /(?:youtube\.com\/watch\?(?:.*&)?v=)([A-Za-z0-9_-]{11})/,
  /(?:youtu\.be\/)([A-Za-z0-9_-]{11})/,
  /(?:youtube\.com\/shorts\/)([A-Za-z0-9_-]{11})/,
  /(?:youtube\.com\/embed\/)([A-Za-z0-9_-]{11})/,
];

export function extractYouTubeId(url: string | null | undefined): string | null {
  if (!url) return null;
  for (const pattern of PATTERNS) {
    const m = pattern.exec(url);
    if (m) return m[1];
  }
  return null;
}
